import { render } from "./add-product.vue?vue&type=template&id=7416a04e&scoped=true"
import script from "./add-product.vue?vue&type=script&lang=js"
export * from "./add-product.vue?vue&type=script&lang=js"

import "./add-product.vue?vue&type=style&index=0&id=7416a04e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7416a04e"]])

export default __exports__